import React, { useEffect } from 'react';
import { Advisor, DepartmentSpec, VehicleRec, ascPageviewInput } from 'src/models';
import CalendarSelectAdvPanel from './CalendarSelectAdvPanel';
import { Flexbox, IView } from '@framework-controls/core';
import { ComponentMapIds } from 'src/components/map';
import { ascPageview } from 'src/helpers/EventHelper/EventHelper';

interface IProps {
    id: string;
    advisors: Advisor[];
    mainPaneViewOrder: IView[];
    vehicles: VehicleRec[];
    selectedVehicle?: string;
    advChange: (advisor: Advisor, event: any) => void;
    selectAdv: string;
    allowTimes: boolean;
    allowTimesName: string;
    deptSpecs: DepartmentSpec;
    theme: string;
}

const CalendarSelectAdv = (props: IProps) => {
    const advBtns = props.advisors.map((advisor) => (
        <CalendarSelectAdvPanel
            key={advisor.advisorNum}
            id='advisorBtn'
            advisor={advisor}
            onSelect={props.advChange}
            selected={props.selectAdv === advisor.advisorNum}
            theme={props.theme}
        />
    ));

    const allowTimesAdv: Advisor = {
        advisorNum: '',
        advisorName: props.allowTimesName,
        advisorPhone: '',
        advisorImage: '',
        defaultFlag: false,
    };

    const noPrefBtn = (
        <CalendarSelectAdvPanel
            id='noPrefBtn'
            advisor={allowTimesAdv}
            onSelect={props.advChange}
            selected={props.selectAdv === ''}
            theme={props.theme}
        />
    );

    useEffect(() => {
        if (props.mainPaneViewOrder[props.mainPaneViewOrder.length - 1].viewId === ComponentMapIds.CalendarSelect) {
            let itemResults = props.advisors.length;
            if (props.allowTimes) {
                itemResults++;
            }
            const ascPageViewInp: ascPageviewInput = {
                pageType: 'service',
                errorCode: '',
                itemResults: itemResults.toString(),
            };
            ascPageview(ascPageViewInp, props.vehicles, props.selectedVehicle);
        }
    }, [props.mainPaneViewOrder, props.allowTimes, props.advisors.length, props.vehicles, props.selectedVehicle]);

    return (
        <Flexbox
            container
            spacing={0}
            direction={'row'}
            noMargin={false}
            justify='flex-start'
        >
            {props.allowTimes === true ? noPrefBtn : null}
            {advBtns}
        </Flexbox>
    );
};

export default CalendarSelectAdv;